// Form Builder Label Translations
// This file contains all text labels used throughout the form builder components
// It includes Italian and English translations for all user-facing strings

export const formBuilderLabels = {
  it: {
    // Core Form Builder
    formBuilder: 'Form Builder',
    formName: 'Nome del Form',
    formCode: 'Codice Form',
    formDescription: 'Descrizione del Form',
    formSections: 'Sezioni del Form',
    formGroup: 'Gruppo',
    selectGroup: 'Seleziona un gruppo',
    basicInformation: 'Informazioni di Base',
    newForm: 'Nuovo Form',
    editForm: 'Modifica Form',
    createNewForm: 'Crea Nuovo Form',
    enterFormName: 'Inserisci il nome del form',
    enterFormCode: 'Inserisci il codice del form',
    enterFormDescription: 'Inserisci la descrizione del form',
    formNameRequired: 'Il nome del form è obbligatorio.',
    formCodeRequired: 'Il codice del form è obbligatorio.',
    formNameExists: 'Un form con questo nome esiste già nel sistema.',
    formCodeExists: 'Un form con questo codice esiste già nel sistema.',
    lisChecklistDashboard: 'Dashboard Checklist LIS', // italian name for the dashboard
    formId: 'Id form',

    // Sections
    addSection: 'Aggiungi Sezione',
    noSections: 'Nessuna sezione aggiunta. Clicca "Aggiungi Sezione" per creare la tua prima sezione.',
    editSection: 'Modifica Sezione',
    deleteSection: 'Elimina Sezione',
    editingSection: 'MODIFICA SEZIONE',
    newSection: 'Nuova Sezione',
    sectionDetails: 'Dettagli della Sezione',
    sectionName: 'Nome Sezione',
    sectionDescription: 'Descrizione Sezione',
    sectionCode: 'Codice Sezione',
    invisible: 'Invisibile',
    notApplicable: 'Considera non applicabile',
    notApplicableHelp: 'Se selezionato, questa risposta verrà esclusa dal calcolo della conformità',
    noName: 'Rendi senza nome',
    mandatory: 'Obbligatorio',
    visibilityConditions: 'Condizioni di Visibilità',
    visibilityConditionsDescription: 'Configura quando questa sezione deve essere mostrata in base alle risposte delle sezioni precedenti',
    showFirstProgressBar: 'Mostra barra di completamento',
    showFirstProgressBarDescription: 'Visualizza la prima barra di progresso compilazione per questa sezione',
    showSecondProgressBar: 'Mostra seconda barra di conformità',
    showSecondProgressBarDescription: 'Visualizza la seconda barra di progresso punteggi per questa sezione',
    showUserGuide: 'Mostra guida utente',
    showUserGuideDescription: 'Abilita la visualizzazione della guida utente durante la compilazione del form',
    isCollaborative: 'Form collaborativo',
    isCollaborativeDescription: 'Abilita la modalità collaborativa per questo form',

    // Collaborative Actors
    collaborativeActors: 'Attori Collaborativi',
    actor: 'Attore',
    actors: 'Attori',
    addActor: 'Aggiungi Attore',
    removeActor: 'Rimuovi Attore',
    actorName: 'Nome Attore',
    noActors: 'Nessun attore configurato',
    noActorsDescription: 'Aggiungi attori per assegnare le domande',
    selectActor: 'Seleziona un attore',
    assignQuestions: 'Assegna Domande',
    assignedQuestions: 'Domande Assegnate',
    availableQuestions: 'Domande Disponibili',
    noQuestionsAssigned: 'Nessuna domanda assegnata a questo attore',
    selectQuestionsToAssign: 'Seleziona le domande da assegnare a questo attore',
    selectSectionsAndQuestionsToAssign: 'Seleziona le sezioni e/o le domande da assegnare a questo attore. Assegnando una sezione verranno assegnate automaticamente tutte le sue domande.',
    actorMustHaveQuestions: 'Ogni attore deve avere almeno una domanda assegnata',
    actorMustHaveQuestionsOrSections: 'Ogni attore deve avere almeno una sezione o domanda assegnata',
    questionsCount: 'domande',
    questionCount: 'domanda',
    sections: 'Sezioni',
    collaborativeFormsSettings: 'Impostazioni Form Collaborativi',
    collaborativeFormsSettingsDescription: 'Configura gli attori e le domande per la compilazione collaborativa del form',
    selectAllAnswers: 'Seleziona/Deseleziona tutte',
    multipleChoice: 'Scelta Multipla',
    optionNotAssignedToYou: 'Questa opzione non è assegnata a te',
    answerAssignedToOtherActor: 'Risposta assegnata ad altro attore',
    answersAssignment: 'Assegnazione Risposte',
    viewAnswers: 'Vedi risposte',
    hideAnswers: 'Nascondi risposte',
    continueCollaborativeForm: 'Continua la form collaborativa nei dettagli',
    waitingForActor: 'In attesa che l\'attore precedente completi',
    currentActor: 'Attore corrente',
    yourTurn: 'Il tuo turno',
    waiting: 'In attesa',
    yourPartCompleted: 'Hai completato la tua parte',
    needsYourAction: 'Richiede la tua azione',
    waitingForOtherActors: 'In attesa di altri attori',

    // User Guide Manager
    userGuideFile: 'File Guida Utente',
    uploadGuideFile: 'Carica File Guida',
    supportedFormats: 'Formati supportati: PDF, DOC, DOCX',
    maxFileSize: 'Dimensione massima: 10MB',
    selectFile: 'Seleziona File',
    invalidFileType: 'Tipo di file non valido. Sono supportati solo PDF e documenti Word.',
    fileTooLarge: 'Il file è troppo grande. Dimensione massima: 10MB.',

    // Context Data Panel
    contextInformation: 'Informazioni di Contesto',
    contextData: 'Dati di Contesto',
    infectionAlert: 'Allerta Infezione',
    microbiologicalTestDetection: 'Rilevamento da test microbiologico',
    patient: 'Paziente',
    male: 'Maschio',
    female: 'Femmina',
    microorganism: 'Microorganismo',
    biologicalMaterial: 'Materiale Biologico',
    testDate: 'Data Test',
    department: 'Reparto',
    contextDataInfo: 'Questi dati sono stati acquisiti automaticamente dal sistema di laboratorio.',
    source: 'Origine',
    saveFormFirst: 'Salva prima il form per poter caricare la guida utente.',
    guideUploadedSuccessfully: 'Guida utente caricata con successo.',
    uploadFailed: 'Caricamento fallito.',
    confirmDeleteGuide: 'Sei sicuro di voler eliminare la guida utente?',
    guideDeletedSuccessfully: 'Guida utente eliminata con successo.',
    deleteFailed: 'Eliminazione fallita.',
    previewFailed: 'Impossibile visualizzare l\'anteprima.',
    userGuideDescription: 'Il file verrà mostrato agli utenti durante la compilazione del form come guida di riferimento.',

    // User Guide Display
    userGuide: 'Guida Utente',
    fullscreen: 'Schermo intero',
    exitFullscreen: 'Esci da schermo intero',
    downloadGuide: 'Scarica Guida',
    guideAvailableForDownload: 'La guida utente è disponibile per il download.',
    guideDocumentPreview: 'Questo documento Word non può essere visualizzato direttamente. Scaricalo per visualizzare il contenuto della guida.',
    livePreview: 'Anteprima Live',
    userGuideAvailable: 'Guida utente disponibile',
    showGuide: 'Mostra Guida',
    failedToLoadGuide: 'Impossibile caricare la guida utente.',
    expand: 'Espandi',
    collapse: 'Riduci',
    uploaded: 'Caricato',
    progressBarSettings: 'Impostazioni Barre di Progresso',
    collaborativeFormsSettings: 'Form Collaborativi',
    collaborativeFormsSettingsDescription: 'Configura le impostazioni per i form collaborativi',

    // Questions
    questions: 'Domande',
    addQuestion: 'Aggiungi Domanda',
    noQuestions: 'Nessuna domanda aggiunta. Clicca "Aggiungi Domanda" per creare la tua prima domanda.',
    editQuestion: 'Modifica Domanda',
    deleteQuestion: 'Elimina Domanda',
    editingQuestion: 'MODIFICA DOMANDA',

    // Progress Bar
    progressCompletion: 'Avanzamento',
    questionsCompleted: 'Domande completate',
    questionsScore: 'Punteggio domande',
    newQuestion: 'Nuova Domanda',
    questionDetails: 'Dettagli della Domanda',
    questionCode: 'Codice Domanda',
    questionText: 'Testo Domanda',
    questionDescription: 'Descrizione Domanda',
    questionType: 'Tipo di Domanda',
    question: 'Domanda',

    // Question Types
    singleChoice: 'Scelta Singola',
    multipleChoice: 'Scelta Multipla',
    textInput: 'Testo Libero',
    textareaInput: 'Testo Lungo',
    numberInput: 'Numero',
    dateInput: 'Data',
    timeInput: 'Ora',
    datetimeInput: 'Data e Ora',
    period: 'Periodo',
    includeTime: 'Includi l\'ora',
    booleanInput: 'Vero/Falso',
    yesNoNA: 'Sì/No/N.A.',
    pdca: 'PDCA',
    vocabulary: 'Vocabolario',
    customVocabulary: 'Vocabolario Personalizzato',
    departmentFunctionalArea: 'Dipartimento/Area Funzionale',
    table: 'Tabella',

    // Table Questions
    tableConfiguration: 'Configurazione Tabella',
    tableSettings: 'Impostazioni Tabella',
    minRows: 'Righe Minime',
    maxRows: 'Righe Massime',
    allowAddRows: 'Permetti aggiunta righe',
    allowDeleteRows: 'Permetti cancellazione righe',
    showRowNumbers: 'Mostra numeri di riga',
    columns: 'Colonne',
    noColumnsConfigured: 'Nessuna colonna configurata',
    addColumn: 'Aggiungi Colonna',
    columnName: 'Nome Colonna',
    columnType: 'Tipo Colonna',
    selectOptions: 'Opzioni di Selezione',
    optionValue: 'Valore opzione',
    optionText: 'Testo opzione',
    addOption: 'Aggiungi Opzione',
    column: 'Colonna',
    required: 'Obbligatorio',
    minLength: 'Lunghezza Min',
    maxLength: 'Lunghezza Max',
    minValue: 'Valore Min',
    maxValue: 'Valore Max',
    addRow: 'Aggiungi Riga',
    deleteRow: 'Elimina riga',
    tableNotConfigured: 'Tabella non configurata. Configurare le colonne nell\'editor delle domande.',
    noDataEntered: 'Nessun dato inserito',
    rows: 'Righe',
    min: 'Min',
    max: 'Max',
    select: 'Seleziona...',
    selectItem: 'seleziona elemento',
    text: 'Testo',
    number: 'Numero',

    // Answers
    answerOptions: 'Opzioni di Risposta',
    trueFalseOptions: 'Opzioni Vero/Falso',
    addAnswer: 'Aggiungi Risposta',
    noAnswers: 'Nessuna risposta aggiunta. Clicca "Aggiungi Risposta" per creare la tua prima opzione di risposta.',
    editAnswer: 'Modifica Risposta',
    deleteAnswer: 'Elimina Risposta',
    editingAnswer: 'MODIFICA RISPOSTA',
    newAnswer: 'Nuova Risposta',
    score: 'Punteggio',
    code: 'Codice',
    answerCode: 'Codice Risposta',
    enterScore: 'Inserisci punteggio',
    enterCode: 'Inserisci codice',

    // Conformity Score
    conformityScore: 'Punteggio di Conformità',
    scoreBasedOnAnswers: 'Punteggio basato sulle risposte',
    scoredQuestions: 'domande con punteggio',
    excellentConformity: 'Conformità eccellente',
    goodConformity: 'Buona conformità',
    fairConformity: 'Conformità discreta',
    answerText: 'Testo Risposta',
    enterAnswerText: 'Inserisci il testo della risposta',
    uniqueIdentifier: 'Un identificatore univoco per questa opzione di risposta (opzionale)',
    numericValue: 'Valore numerico associato a questa risposta',
    enterNumericValue: 'Inserisci valore numerico',

    // File Upload
    allowFileUpload: 'Consenti caricamento file',
    allowLinkUpload: 'Consenti inserimento link',
    allowTextUpload: 'Consenti inserimento testo',
    allowObservations: 'Consenti osservazioni',
    attachments: 'Allegati',
    file: 'File',
    link: 'Link',
    text: 'Testo',
    observation: 'Osservazione',
    dropFileHere: 'Trascina file qui',
    orClickToSelect: 'o clicca per selezionare',
    chooseFiles: 'Scegli file',
    selectFile: 'Seleziona File',
    loadingFiles: 'Caricamento file...',
    uploadFromDevice: 'Carica dal dispositivo',
    failedToRetrieveFiles: 'Impossibile recuperare i file',
    noFilesFound: 'Nessun file trovato',
    uploading: 'Caricamento...',
    uploadSuccess: 'File caricato con successo',
    uploadError: 'Errore durante il caricamento del file',
    uploadFile: 'Carica file',
    dragFilesHere: 'Trascina file qui',
    enterLinkUrl: 'Inserisci URL del link',
    enterLinkDescription: 'Inserisci descrizione del link',
    enterTextContent: 'Inserisci contenuto di testo',
    enterObservation: 'Inserisci osservazione',
    modalDescriptionDetail: 'I file presenti in questa lista sono stati precedentemente caricati. I file già allegati non sono mostrati.',

    // Department/Functional Area
    department: 'Dipartimento',
    functionalArea: 'Area Funzionale',
    selectDepartment: 'Seleziona Dipartimento',
    selectFunctionalArea: 'Seleziona Area Funzionale',

    // Input placeholders
    enterAnswer: 'Inserisci risposta',
    enterNumberAnswer: 'Inserisci numero',

    // Actions
    save: 'Salva',
    saving: 'Salvataggio in corso...',
    savingMessage: 'Attendere prego mentre il form viene salvato.',
    done: 'Fatto',
    confirm: 'Conferma',
    cancel: 'Annulla',
    close: 'Chiudi',
    delete: 'Elimina',
    edit: 'Modifica',
    editing: 'MODIFICA',
    clone: 'Clona',
    cloning: 'Clonazione in corso...',
    cloneSuccess: 'Clonazione completata con successo',
    cloneError: 'Errore durante la clonazione',
    cloningQuestion: 'Clonazione domanda in corso...',
    cloneQuestionSuccess: 'Domanda clonata con successo',
    deleteForm: 'Elimina form',
    confirmDelete: 'Sei sicuro di voler eliminare questo form?',
    deleteSuccess: 'Form eliminato con successo',
    deleteError: 'Errore durante l\'eliminazione del form',
    actions: 'Azioni',
    search: 'Cerca',
    clear: 'Cancella',
    assignForm: 'Assegna form',

    // Finder specific labels
    date: 'Data di creazione',
    createdBy: 'Creato da',
    findedElements: 'Elementi trovati',
    filter: 'Filtro',
    formBuilderFinder: 'Ricerca Form Builder',
    noResults: 'Nessun risultato trovato',

    // Language
    selectLanguage: 'Seleziona lingua',
    english: 'Inglese',
    italian: 'Italiano',
    enterTextIn: 'Inserisci testo in',

    // Simulation
    simulation: 'Simulazione',
    simulateForm: 'Simula form',
    compileForm: 'Compila form',

    // Messages
    success: 'Operazione Completata',
    error: 'Errore',
    attention: 'Attenzione',
    loading: 'Caricamento...',
    saveSuccess: 'Form salvato con successo.',
    createSuccess: 'Form creato con successo.',
    updateSuccess: 'Form aggiornato con successo.',
    saveError: 'Si è verificato un errore durante il salvataggio del form.',
    duplicateCodesFound: 'Sono stati trovati codici duplicati nel form:',
    invalidResponse: 'Il server ha restituito una risposta non valida. Controlla l\'endpoint API e la configurazione del server.',
    mandatorySectionError: 'La sezione "{sectionName}" è obbligatoria e contiene domande senza risposta. Completare tutte le domande prima di salvare.',
    mandatoryQuestionInSection: 'Domande obbligatorie nella sezione',

    // Navigation
    home: 'Home',
    form: 'Form',
    searchForms: 'Cerca form',
    formsDashboard: 'Dashboard Form',
    formsDashboardWelcome: 'Benvenuto nella Dashboard Form.',

    // Boolean values
    yes: 'Sì',
    no: 'No',
    true: 'Vero',
    false: 'Falso',

    // Dashboard specific
    healthAuthority: 'Autorità Sanitaria',
    departmentCategory: 'Categoria del reparto',
    customDepartmentCategory: 'Categoria custom per il reparto',
    observer: 'Osservatore',
    sessionLength: 'Durata sessione',
    notes: 'Note',
    startDate: 'Periodo di inizio',
    endDate: 'Periodo di fine',
    id: 'Id',
    startEnd: 'Ora d\'inizio e fine',
    notesPlaceholder: 'Scrivi le tue note qui',
    savingData: 'Stiamo salvando i tuoi dati',
    handHygieneSavedSuccesfully: 'Scheda igiene mani salvata con successo',
    handHygieneSavingError: 'Errore nella salvataggio della scheda igiene mani',
    departmentTypeRequired: 'La tipologia del reparto non è stata selezionata',
    startDateTimeRequired: 'L\'orario di inizio dell\'osservazione non è stato selezionato',
    endDateTimeRequired: 'L\'orario di fine dell\'osservazione non è stato selezionato',
    endDateTimeBeforeStart: 'L\'orario di fine non può essere precedente a quello di inizio',
    departmentRequired: 'Il campo reparto è obbligatorio',
    functionalAreaRequired: 'Il campo Area funzionale è obbligatorio',
    opportunityMissingOperator: 'Ci sono opportunità nell\'OPP {{opp}} ma manca l\'operatore',
    incompleteOpportunity: 'L\'OPP {{oppIndex}} dell\'operatore {{operatorOrder}} è incompleta: devi selezionare sia l\'indicazione che l\'azione',
    nothingToSave: 'Niente da salvare',
    acpm: 'Acpm',
    note: 'Note',
    opp: 'Opp',
    pageRows: 'Righe per pagina:',
    backPage: 'Precedente',
    nextPage: 'Successivo',
    pageOf: 'Pagina {{currentPage}} di {{totalPages}}',
    emptyAssigned: "Nessun form assegnato",
    emptySaved: "Nessun form salvato",
    emptyCompiled: "Nessun form compilato",
    emptyApproved: "Nessun form approvato",
    Name: 'Nome',
    Description: 'Descrizione',
    Group: 'Gruppo',
    Code: 'Codice',
    Status: 'Stato',
    Assigned: 'Assegnata',
    Saved: 'Salvata',
    Compiled: 'Compilata',
    Approved: 'Approvata',
    CompiledForms: 'Form compilati',

    // Sections Builder specific
    cloneSection: 'Clona sezione',

    // Questions Builder specific
    type: 'Tipo',
    openAnswer: 'Risposta Aperta',
    openNumberAnswer: 'Risposta Aperta (Numeri)',
    files: 'File',
    answers: 'Risposte',
    condition: 'Condizione',
    date: 'Data',
    time: 'Ora',
    datetime: 'Data e Ora',
    table: 'Tabella',

    // Validation Dashboard specific  
    validationDashboard: 'Dashboard Validazione',
    selectUser: 'Seleziona utente',
    selectForm: 'Seleziona form',
    Compiler: 'Compilatore',
    CreatedDate: 'Data Creazione',
    validate: 'Valida',
    validationSuccess: 'Form validato con successo',
    validationError: 'Errore durante la validazione del form',
    confirmValidation: 'Sei sicuro di voler validare questo form?',
    requiresValidation: 'Richiede validazione',
    validated: 'Validato',
    validatedBy: 'Validato da',
    validatedDate: 'Data validazione',
    view: 'Visualizza',
    viewForm: 'Visualizza Form',
    loadingFormData: 'Caricamento dati form...',
    failedToLoadForm: 'Impossibile caricare i dati del form',
    viewingForm: 'Visualizzazione Form',

    // Form Assignment specific
    formAssignment: 'Assegnazione Form',
    assign: 'Assegna',
    assignSuccess: 'Form assegnato con successo',
    assignError: 'Errore durante l\'assegnazione del form',
    formAssignmentInfo: 'Seleziona un utente a cui assegnare il form',
    userRequired: 'Seleziona almeno un utente o un form',
    back: 'Indietro',
    requiredField: 'Campo obbligatorio',
    expectedStartDate: 'Data inizio prevista',
    expectedEndDate: 'Data fine prevista',
    assignToUser: 'Assegna a utente',
    assignToGroup: 'Assegna a gruppo',
    collaborativeAssignment: 'Assegnazione Collaborativa',
    collaborativeAssignmentInfo: 'Assegnazione collaborativa: seleziona un form collaborativo per creare un\'assegnazione aperta a tutti gli utenti.',
    actorRoleMapping: 'Assegnazione Attori ai Ruoli',
    actorRoleMappingRequired: 'Tutti gli attori devono essere assegnati ad almeno un ruolo per procedere.',
    selectRoles: 'Seleziona uno o più ruoli',
    selectRoleToAdd: 'Seleziona un ruolo da aggiungere',
    assignedRoles: 'Ruoli assegnati',
    noRolesAssigned: 'Nessun ruolo assegnato',
    noActorsFound: 'Nessun attore trovato per questo form',
    actorsWithoutRoles: 'I seguenti attori non hanno ruoli assegnati',
    remove: 'Rimuovi',
    selectGroup: 'Seleziona gruppo',
    groupRequired: 'Seleziona almeno un gruppo o un form',
    cycles: 'Cicli',
    selectBusinessUnits: 'Seleziona Business Unit',
    selectBusinessUnitToAdd: 'Seleziona una business unit da aggiungere',
    selectedBusinessUnits: 'Business Unit selezionate',
    noBusinessUnitsSelected: 'Nessuna business unit selezionata',
    businessUnitsInfo: 'Seleziona una o più business unit per questa assegnazione collaborativa.',
    businessUnitRequired: 'Seleziona almeno una business unit',
    freeAssignments: 'Assegnazioni libere',
    freeAssignmentsInfo: 'Permette di assegnare attori a tutti gli utenti',
    assignmentWithNotification: 'Assegnazione con notifica',
    assignmentWithNotificationInfo: 'Invia notifica agli utenti in base all\'ordine di compilazione',
    allUsersInfo: 'Questo attore può essere compilato da tutti gli utenti',
    rolesDisabledForAllUsers: 'La selezione dei ruoli è disabilitata quando "Tutti gli utenti" è attivo',
    importantNote: 'Nota importante',
    allUsersOrderRestriction: 'Gli attori con "Tutti gli utenti" devono essere posizionati all\'inizio della sequenza di compilazione. Dopo un attore con ruoli specifici, non è più possibile inserire attori con "Tutti gli utenti". Almeno un attore deve avere ruoli specifici.',
    atLeastOneActorWithRoles: 'Almeno un attore deve avere ruoli specifici assegnati. Non tutti gli attori possono essere impostati su "Tutti gli utenti".',
    allUsersActorsMustBeFirst: 'Gli attori con "Tutti gli utenti" devono essere posizionati all\'inizio della sequenza di compilazione.',
    newAssignment: 'Nuova Assegnazione',
    searchAssignments: 'Ricerca assegnazioni',
    searchAssignmentsInfo: 'Cerca e gestisci le assegnazioni esistenti utilizzando i filtri sottostanti.',
    comingSoon: 'Prossimamente',
    searchAssignmentsComingSoon: 'La funzionalità di ricerca assegnazioni sarà disponibile a breve.',
    allUsers: 'Tutti gli utenti',
    allGroups: 'Tutti i gruppi',
    allValidationTypes: 'Tutti i tipi',
    searchDateFrom: 'Data inizio da',
    searchDateTo: 'Data fine entro',
    includeInactive: 'Includi inattivi',
    searching: 'Ricerca...',
    searchResults: 'Risultati ricerca',
    noAssignmentsFound: 'Nessuna assegnazione trovata',
    useFiltersToSearch: 'Utilizza i filtri sopra per cercare le assegnazioni e clicca "Cerca".',
    assignedTo: 'Assegnato a',
    assignmentType: 'Tipo',
    createdDate: 'Data creazione',
    status: 'Stato',
    user: 'Utente',
    group: 'Gruppo',
    searchError: 'Errore durante la ricerca delle assegnazioni',
    allForms: 'Tutti i form',
    endDateMustBeAfterStartDate: 'La data fine deve essere successiva alla data inizio',
    startDateMustBeBeforeEndDate: 'La data inizio deve essere precedente alla data fine',
    editAssignment: 'Modifica Assegnazione',
    editAssignmentInfo: 'Modifica i dettagli dell\'assegnazione selezionata.',
    confirmSave: 'Conferma salvataggio',
    areYouSureToSave: 'Sei sicuro di voler salvare le modifiche?',
    updateSuccess: 'Assegnazione aggiornata con successo',
    updateError: 'Errore durante l\'aggiornamento',
    confirmDelete: 'Conferma eliminazione',
    areYouSureToDelete: 'Sei sicuro di voler eliminare questa assegnazione? Questa azione non può essere annullata.',
    deleting: 'Eliminazione in corso...',
    deleteSuccess: 'Assegnazione eliminata con successo',
    deleteError: 'Errore durante l\'eliminazione',
    saveChanges: 'Salva modifiche',
    compilationOrder: 'Ordine di compilazione',
    order: 'Ordine',
    resetOrder: 'Reimposta ordine',
    duplicateOrderValues: 'Ogni attore deve avere un ordine di compilazione univoco. Verifica che non ci siano duplicati.',
    invalidOrderRange: 'L\'ordine deve essere compreso tra 1 e',
    searchUserPlaceholder: 'Digita almeno 3 caratteri per cercare utenti...',
    searchGroupPlaceholder: 'Digita almeno 3 caratteri per cercare gruppi...',
    noUsersFound: 'Nessun utente trovato',
    noGroupsFound: 'Nessun gruppo trovato',

    // Notification Settings
    notificationSettings: 'Impostazioni Notifica',
    automaticNotification: 'Automatica',
    customNotification: 'Personalizzata',
    notificationEmails: 'Email per notifiche',
    enterEmail: 'Inserisci email...',
    noEmailsAdded: 'Nessuna email aggiunta',
    emailEmpty: 'L\'email non può essere vuota',
    emailInvalid: 'Formato email non valido',
    emailDuplicate: 'Questa email è già presente nella lista',
    customNotificationRequiresEmails: 'La notifica personalizzata richiede almeno un\'email',

    // New Dashboard specific
    assignmentsDashboard: 'Dashboard Assegnazioni',
    assignmentsDashboardDescription: 'Gestisci e monitora le tue assegnazioni di form.',
    activeAssignments: 'Assegnazioni Attive',
    completedAssignments: 'Assegnazioni Completate',
    assignmentPeriod: 'Periodo Assegnazione',
    completedCycles: 'Cicli Completati',
    remainingCycles: 'Cicli Rimanenti',
    totalCycles: 'Cicli Totali',
    formCompletions: 'Compilazioni Form',
    compiledBy: 'Compilato da',
    completedCycle: 'Ciclo Completato',
    noCompletionsYet: 'Nessuna compilazione ancora disponibile',
    noActiveAssignments: 'Nessuna assegnazione attiva',
    noCompletedAssignments: 'Nessuna assegnazione completata',
    noActiveAssignmentsDescription: 'Al momento non hai assegnazioni di form attive.',
    noCompletedAssignmentsDescription: 'Non hai ancora completato nessuna assegnazione.',
    allCyclesCompleted: 'Tutti i cicli per questa assegnazione sono stati completati.',
    assignedToGroup: 'Assegnato al gruppo',
    details: 'dettagli',
    viewingForm: 'Visualizzazione Form',
    loadingFormData: 'Caricamento dati form...',
    failedToLoadForm: 'Impossibile caricare i dati del form',
    refresh: 'Aggiorna',
    view: 'Visualizza',

    // Compiler specific
    enterText: 'Inserisci testo',
    option: 'Opzione',
    section: 'Sezione',
    chooseFile: 'Scegli file',
    chooseFromExisting: 'Scegli da esistenti',
    uploadNewFile: 'Carica un nuovo file',
    fileSelected: 'File selezionato',
    fileUploaded: 'File caricato',
    orClickToSelect: 'o clicca per selezionare',
    fileUploadSuccessful: 'File caricato con successo',
    noFileSelected: 'Nessun file selezionato',
    fileSize: 'Dimensione',
    lastUpdated: 'Ultimo aggiornamento',
    enterLink: 'Inserisci URL',
    enterObservation: 'Inserisci osservazione',
    linkAdded: 'Link aggiunto',
    observationAdded: 'Osservazione aggiunta',
    providedLink: 'Link fornito',
    providedObservation: 'Osservazione fornita',
    enterValidUrl: 'Inserisci un URL valido',
    attachment: 'Allegato',
    textAdded: 'Testo aggiunto',
    providedText: 'Testo fornito',
    na: 'Non Applicabile',
    selectDate: 'Seleziona data',
    selectTime: 'Seleziona ora',
    selectDateTime: 'Seleziona data e ora',
    selectVocabulary: 'Seleziona dal vocabolario',
    selectCustomVocabulary: 'Seleziona Vocabolario Personalizzato',
    loadingVocabulary: 'Caricamento vocabolario...',
    loadingVocabularies: 'Caricamento vocabolari...',
    customVocabularyColumnHelp: 'Le celle della colonna mostreranno un elenco dal vocabolario selezionato.',
    noVocabularyItemsFound: 'Nessun elemento trovato in questo vocabolario',
    loadingDepartments: 'Caricamento dipartimenti...',
    loadingFunctionalAreas: 'Caricamento aree funzionali...',
    readOnlyMode: 'Modalità Sola Lettura',
    readOnlyInfo: 'Questo form è in modalità sola lettura. Non è possibile modificare le risposte.',
    formTest: 'Test del Form',
    formSimulation: 'Questa è una simulazione del form. Le risposte non saranno salvate.',
    submitAnswers: 'Invia Risposte',
    formSubmittedSuccessfully: 'Form inviato con successo.',
    formCompilation: 'Compilazione Form',
    formCompilationInfo: 'Compila il form e salva le tue risposte.',
    savingFormData: 'Salvataggio dei dati del form',
    formSavedSuccessfully: 'Form salvato con successo',
    failedToSaveForm: 'Impossibile salvare il form',
    reload: 'Ricarica Form',
    reloadConfirmation: 'Questo ricaricherà il form con gli ultimi dati salvati. Eventuali modifiche non salvate andranno perse. Continuare?',
    mandatorySectionIncomplete: 'Sezione obbligatoria incompleta',
    incompleteMandatoryQuestions: 'Domande non completate',
    validationError: 'Errore di validazione',
    submitting: 'Invio in corso...',
    submittingFormData: 'Invio dei dati del form',
    failedToSubmitForm: 'Impossibile inviare il form',

    // Question Validation System
    validationRules: 'Regole di Validazione',
    validationRulesNote: 'Queste regole vengono applicate automaticamente durante la compilazione.',
    validationRule: 'Regola di validazione',
    optionDisabledByValidation: 'Opzione disabilitata dalle regole di validazione',
    anyOfThese: 'almeno una di queste',
    allOfThese: 'tutte queste',
    noneOfThese: 'nessuna di queste',
    mustSelectOneOf: 'deve selezionare almeno una di',
    mustSelectAllOf: 'deve selezionare tutte',
    cannotSelect: 'non può selezionare',
    if: 'Se',
    then: 'allora',
    // Validation editor interface
    validationRulesInfo: 'Come funzionano le regole di validazione',
    validationRulesDescription: 'Le regole seguono la logica "SE/ALLORA" per controllare le combinazioni di risposte permesse. Ogni regola definisce una condizione di attivazione e un\'azione risultante.',
    noValidationRules: 'Nessuna regola di validazione configurata',
    clickAddRule: 'Clicca "Aggiungi Regola" per iniziare',
    rule: 'Regola',
    removeRule: 'Rimuovi regola',
    sourceCondition: 'Condizione di attivazione',
    sourceAnswers: 'Risposte di attivazione',
    destCondition: 'Azione risultante',
    destAnswers: 'Risposte interessate',
    preview: 'Anteprima',
    addRule: 'Aggiungi Regola',
    any_of: 'almeno una di queste',
    all: 'tutte queste',
    not_in: 'nessuna di queste',
    mandatory_any: 'deve selezionare almeno una di',
    mandatory_all: 'deve selezionare tutte',
    excluded_all: 'non può selezionare',

    // File operations
    download: 'Scarica',

    // Link and Text operations
    providedLink: 'Link fornito',
    enterLink: 'Inserisci link',
    linkAdded: 'Link aggiunto',
    enterValidUrl: 'Inserisci un URL valido',
    providedText: 'Testo fornito',
    enterText: 'Inserisci testo',
    textAdded: 'Testo aggiunto',
    providedObservation: 'Osservazione fornita',
    observationAdded: 'Osservazione aggiunta',

    // Conditions
    createCondition: 'Crea una condizione per controllare quando questa domanda appare',
    selectConditionType: 'Seleziona il tipo di condizione...',
    andGroup: 'Gruppo AND (tutte le condizioni devono essere vere)',
    orGroup: 'Gruppo OR (una qualsiasi condizione può essere vera)',
    operator: 'Operatore',
    answer: 'Risposta',
    selectQuestion: 'Seleziona domanda...',
    selectAnswer: 'Seleziona risposta...',
    isEqualTo: 'è uguale a',
    isNotEqualTo: 'non è uguale a',
    removeCondition: 'Rimuovi condizione',
    addCondition: 'Aggiungi Condizione',
    addAnd: 'Aggiungi AND',
    addOr: 'Aggiungi OR',
    removeEntireCondition: 'Rimuovi l\'intera condizione',
    allMustBeTrue: 'Tutte devono essere vere',
    anyCanBeTrue: 'Una qualsiasi può essere vera',
    addConditionsOrGroups: 'Aggiungi condizioni o gruppi utilizzando i pulsanti sopra',
    loadingQuestions: 'Caricamento domande...',

    // Validation
    required: 'Obbligatorio',
    optional: 'Opzionale',

    // Default Answers
    defaultAnswers: 'Risposte di Default',
    selectDefaultAnswers: 'Seleziona risposte di default (opzionale)',
    singleDefaultHelp: 'Seleziona una risposta che sarà preselezionata di default',
    multipleDefaultHelp: 'Seleziona una o più risposte che saranno preselezionate di default',
    booleanDefaultHelp: 'Seleziona il valore di default vero/falso',
    yesNoNADefaultHelp: 'Seleziona il valore di default sì/no/non applicabile',
    pdcaDefaultHelp: 'Seleziona una o più opzioni PDCA di default',
    customVocabularyDefaultHelp: 'Seleziona uno o più elementi di default dal vocabolario personalizzato',
    clearDefaultAnswers: 'Cancella Risposte di Default',
    hide: 'Nascondi',
    show: 'Mostra',

    // Export Form
    exportForm: 'Esporta Form',
    exporting: 'Esportazione in corso...',
    exportingForm: 'Esportazione del form in corso, attendere prego.',
    exportSuccess: 'Form esportato con successo',
    exportError: 'Errore durante l\'esportazione del form',
    noFormToExport: 'Nessun form da esportare',
    saveBeforeExport: 'Salva le modifiche prima di esportare il form',

    // Import Form
    importForm: 'Importa Form',
    importing: 'Importazione in corso...',
    importingForm: 'Importazione del form in corso, attendere prego.',
    importSuccess: 'Form importato con successo',
    importError: 'Errore durante l\'importazione del form',
    invalidFileFormat: 'Formato file non valido. Il file deve essere un JSON valido.',

    // Table specific labels
    tableData: 'Dati Tabella',
    tableEmpty: 'Nessun dato nella tabella',
    tableRowAdded: 'Riga aggiunta',
    tableRowDeleted: 'Riga eliminata',
    tableRowDeleteConfirm: 'Sei sicuro di voler eliminare questa riga?',
    tableColumnName: 'Nome Colonna',
    tableColumnType: 'Tipo Colonna',
    tableColumnRequired: 'Colonna Obbligatoria',
    tableRow: 'Riga',
    tableAction: 'Azione',
    tableNoColumns: 'Nessuna colonna configurata per questa tabella',
    tableConfigureColumns: 'Configura le colonne nelle impostazioni della domanda',
    rowNumber: 'N.',
    cannotDeleteVocabularyItems: 'Non puoi eliminare elementi del vocabolario',
    cannotAddVocabularyItems: 'Non puoi aggiungere elementi personalizzati al vocabolario',
    cannotReorderVocabularyItems: 'Non puoi riordinare elementi del vocabolario',
    noFilesRequired: 'Nessun file richiesto',
    add: 'Aggiungi',
    placeholder: 'Segnaposto',

    // ACPM (Azioni Correttive e Piani di Miglioramento) Labels
    acpmFinder: 'Ricerca Form ACPM',
    acpmList: 'Elenco Form ACPM',
    objective: 'Obiettivo',
    action: 'Azione',
    responsabile: 'Responsabile',
    dataInizio: 'Data inizio',
    dataFine: 'Data fine',
    stato: 'Stato',
    esito: 'Esito',
    acpmFormsList: 'Form ACPM trovati',
    loadingACPMForms: 'Caricamento form ACPM...',
    errorLoadingACPMForms: 'Errore nel caricamento dei form ACPM',
    noACPMFormsFound: 'Nessun form ACPM trovato',
    acpmFormCode: 'Codice ACPM',
    viewDetails: 'Visualizza dettagli',
    refreshACPMList: 'Aggiorna elenco ACPM',

    // Collaborative Form Lock System
    formLocked: 'Form in uso',
    formLockedBy: 'In modifica da',
    formLockedMessage: 'Questo form è attualmente in modifica da un altro utente. Non è possibile modificarlo in questo momento.',
    lockActive: 'Stai modificando',
    lockActiveMessage: 'Hai il controllo esclusivo di questo form collaborativo',
    lockError: 'Errore di blocco',
    lockErrorMessage: 'Si è verificato un errore durante l\'acquisizione del blocco del form',
    retryLock: 'Riprova',
    backToList: 'Torna alla lista',
    acquiringLock: 'Acquisizione blocco...',
    acquiringLockMessage: 'Attendere mentre si acquisisce il blocco del form collaborativo',
    lockDisconnected: 'Disconnesso',
    lockDisconnectedMessage: 'Sei stato disconnesso dal form. Il blocco è stato rilasciato.'
  },

  en: {
    // Core Form Builder
    formBuilder: 'Form Builder',
    formName: 'Form Name',
    formCode: 'Form Code',
    formDescription: 'Form Description',
    formSections: 'Form Sections',
    formGroup: 'Group',
    selectGroup: 'Select a group',
    basicInformation: 'Basic Information',
    newForm: 'New Form',
    editForm: 'Edit Form',
    createNewForm: 'Create New Form',
    enterFormName: 'Enter form name',
    enterFormCode: 'Enter form code',
    enterFormDescription: 'Enter form description',
    formNameRequired: 'Form name is required.',
    formCodeRequired: 'Form code is required.',
    formNameExists: 'A form with this name already exists in the system.',
    formCodeExists: 'A form with this code already exists in the system.',
    lisChecklistDashboard: 'Dashboard Checklist LIS',
    formId: 'Id form',

    // Sections
    addSection: 'Add Section',
    noSections: 'No sections added yet. Click "Add Section" to create your first section.',
    editSection: 'Edit Section',
    deleteSection: 'Delete Section',
    editingSection: 'EDITING SECTION',
    newSection: 'New Section',
    sectionDetails: 'Section Details',
    sectionName: 'Section Name',
    sectionDescription: 'Section Description',
    sectionCode: 'Section Code',
    invisible: 'Invisible',
    notApplicable: 'Consider not applicable',
    notApplicableHelp: 'If selected, this answer will be excluded from conformity score calculation',
    noName: 'Make nameless',
    mandatory: 'Mandatory',
    visibilityConditions: 'Visibility Conditions',
    visibilityConditionsDescription: 'Configure when this section should be shown based on answers from previous sections',
    showFirstProgressBar: 'Show first progress bar',
    showFirstProgressBarDescription: 'Display the first completion progress bar for this section',
    showSecondProgressBar: 'Show second progress bar',
    showSecondProgressBarDescription: 'Display the second scores progress bar for this section',
    showUserGuide: 'Show user guide',
    showUserGuideDescription: 'Enable user guide display during form completion',
    isCollaborative: 'Collaborative form',
    isCollaborativeDescription: 'Enable collaborative mode for this form',

    // Collaborative Actors
    collaborativeActors: 'Collaborative Actors',
    actor: 'Actor',
    actors: 'Actors',
    addActor: 'Add Actor',
    removeActor: 'Remove Actor',
    actorName: 'Actor Name',
    noActors: 'No actors configured',
    noActorsDescription: 'Add actors to assign questions',
    selectActor: 'Select an actor',
    assignQuestions: 'Assign Questions',
    assignedQuestions: 'Assigned Questions',
    availableQuestions: 'Available Questions',
    noQuestionsAssigned: 'No questions assigned to this actor',
    selectQuestionsToAssign: 'Select questions to assign to this actor',
    selectSectionsAndQuestionsToAssign: 'Select sections and/or questions to assign to this actor. Assigning a section will automatically assign all its questions.',
    actorMustHaveQuestions: 'Each actor must have at least one assigned question',
    actorMustHaveQuestionsOrSections: 'Each actor must have at least one section or question assigned',
    questionsCount: 'questions',
    questionCount: 'question',
    sections: 'Sections',
    collaborativeFormsSettings: 'Collaborative Forms Settings',
    collaborativeFormsSettingsDescription: 'Configure actors and questions for collaborative form completion',
    selectAllAnswers: 'Select/Deselect all',
    multipleChoice: 'Multiple Choice',
    optionNotAssignedToYou: 'This option is not assigned to you',
    answerAssignedToOtherActor: 'Answer assigned to another actor',
    answersAssignment: 'Answers Assignment',
    viewAnswers: 'View answers',
    hideAnswers: 'Hide answers',
    continueCollaborativeForm: 'Continue the collaborative form in details',
    waitingForActor: 'Waiting for previous actor to complete',
    currentActor: 'Current actor',
    yourTurn: 'Your turn',
    waiting: 'Waiting',
    yourPartCompleted: 'You completed your part',
    needsYourAction: 'Needs your action',
    waitingForOtherActors: 'Waiting for other actors',

    // User Guide Manager
    userGuideFile: 'User Guide File',
    uploadGuideFile: 'Upload Guide File',
    supportedFormats: 'Supported formats: PDF, DOC, DOCX',
    maxFileSize: 'Maximum size: 10MB',
    selectFile: 'Select File',
    invalidFileType: 'Invalid file type. Only PDF and Word documents are supported.',
    fileTooLarge: 'File is too large. Maximum size: 10MB.',

    // Context Data Panel
    contextInformation: 'Context Information',
    contextData: 'Context Data',
    infectionAlert: 'Infection Alert',
    microbiologicalTestDetection: 'Detection from microbiological test',
    patient: 'Patient',
    male: 'Male',
    female: 'Female',
    microorganism: 'Microorganism',
    biologicalMaterial: 'Biological Material',
    testDate: 'Test Date',
    department: 'Department',
    contextDataInfo: 'This data has been automatically acquired from the laboratory system and provides context for form completion.',
    source: 'Source',
    saveFormFirst: 'Save the form first to upload the user guide.',
    guideUploadedSuccessfully: 'User guide uploaded successfully.',
    uploadFailed: 'Upload failed.',
    confirmDeleteGuide: 'Are you sure you want to delete the user guide?',
    guideDeletedSuccessfully: 'User guide deleted successfully.',
    deleteFailed: 'Deletion failed.',
    previewFailed: 'Unable to preview.',
    userGuideDescription: 'The file will be shown to users during form compilation as a reference guide.',

    // User Guide Display
    userGuide: 'User Guide',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit fullscreen',
    downloadGuide: 'Download Guide',
    guideAvailableForDownload: 'The user guide is available for download.',
    guideDocumentPreview: 'This Word document cannot be displayed directly. Download it to view the guide content.',
    livePreview: 'Live Preview',
    userGuideAvailable: 'User guide available',
    showGuide: 'Show Guide',
    failedToLoadGuide: 'Unable to load user guide.',
    expand: 'Expand',
    collapse: 'Collapse',
    uploaded: 'Uploaded',
    progressBarSettings: 'Progress Bar Settings',
    collaborativeFormsSettings: 'Collaborative Forms',
    collaborativeFormsSettingsDescription: 'Configure settings for collaborative forms',

    // Questions
    questions: 'Questions',
    addQuestion: 'Add Question',
    noQuestions: 'No questions added yet. Click "Add Question" to create your first question.',
    editQuestion: 'Edit Question',
    deleteQuestion: 'Delete Question',
    editingQuestion: 'EDITING QUESTION',

    // Progress Bar
    progressCompletion: 'Progress',
    questionsCompleted: 'Questions completed',
    questionsScore: 'Questions Score',

    newQuestion: 'New Question',
    questionDetails: 'Question Details',
    questionCode: 'Question Code',
    questionText: 'Question Text',
    questionDescription: 'Question Description',
    questionType: 'Question Type',
    question: 'Question',

    // Question Types
    singleChoice: 'Single Choice',
    multipleChoice: 'Multiple Choice',
    textInput: 'Text Input',
    textareaInput: 'Long Text',
    numberInput: 'Number',
    dateInput: 'Date',
    timeInput: 'Time',
    datetimeInput: 'Date and Time',
    period: 'Period',
    includeTime: 'Include time',
    booleanInput: 'True/False',
    yesNoNA: 'Yes/No/N.A.',
    pdca: 'PDCA',
    vocabulary: 'Vocabulary',
    customVocabulary: 'Custom Vocabulary',
    departmentFunctionalArea: 'Department/Functional Area',
    table: 'Table',

    // Table Questions
    tableConfiguration: 'Table Configuration',
    tableSettings: 'Table Settings',
    minRows: 'Minimum Rows',
    maxRows: 'Maximum Rows',
    allowAddRows: 'Allow adding rows',
    allowDeleteRows: 'Allow deleting rows',
    showRowNumbers: 'Show row numbers',
    columns: 'Columns',
    noColumnsConfigured: 'No columns configured',
    addColumn: 'Add Column',
    columnName: 'Column Name',
    columnType: 'Column Type',
    selectOptions: 'Selection Options',
    optionValue: 'Option value',
    optionText: 'Option text',
    addOption: 'Add Option',
    column: 'Column',
    required: 'Required',
    minLength: 'Min Length',
    maxLength: 'Max Length',
    minValue: 'Min Value',
    maxValue: 'Max Value',
    addRow: 'Add Row',
    deleteRow: 'Delete row',
    tableNotConfigured: 'Table not configured. Configure columns in the question editor.',
    noDataEntered: 'No data entered',
    rows: 'Rows',
    min: 'Min',
    max: 'Max',
    select: 'Select...',
    selectItem: 'Select item',
    text: 'Text',
    number: 'Number',

    // Answers
    answerOptions: 'Answer Options',
    trueFalseOptions: 'True/False Options',
    addAnswer: 'Add Answer',
    noAnswers: 'No answers added yet. Click "Add Answer" to create your first answer option.',
    editAnswer: 'Edit Answer',
    deleteAnswer: 'Delete Answer',
    editingAnswer: 'EDITING ANSWER',
    newAnswer: 'New Answer',
    score: 'Score',
    code: 'Code',
    answerCode: 'Answer Code',
    enterScore: 'Enter score',
    enterCode: 'Enter code',

    // Conformity Score
    conformityScore: 'Conformity Score',
    scoreBasedOnAnswers: 'Score based on answers',
    scoredQuestions: 'scored questions',
    excellentConformity: 'Excellent conformity',
    goodConformity: 'Good conformity',
    fairConformity: 'Fair conformity',
    answerText: 'Answer Text',
    enterAnswerText: 'Enter answer text',
    uniqueIdentifier: 'A unique identifier for this answer option (optional)',
    numericValue: 'Numeric value associated with this answer',
    enterNumericValue: 'Enter numeric value',

    // File Upload
    allowFileUpload: 'Allow file upload',
    allowLinkUpload: 'Allow link upload',
    allowTextUpload: 'Allow text upload',
    allowObservations: 'Allow observations',
    attachments: 'Attachments',
    file: 'File',
    link: 'Link',
    text: 'Text',
    observation: 'Observation',
    dropFileHere: 'Drop files here',
    orClickToSelect: 'or click to select',
    chooseFiles: 'Choose files',
    selectFile: 'Select File',
    loadingFiles: 'Loading files...',
    uploadFromDevice: 'Upload from device',
    failedToRetrieveFiles: 'Failed to retrieve files',
    noFilesFound: 'No files found',
    uploading: 'Uploading...',
    uploadSuccess: 'File uploaded successfully',
    uploadError: 'Error uploading file',
    uploadFile: 'Upload file',
    dragFilesHere: 'Drag files here',
    enterLinkUrl: 'Enter link URL',
    enterLinkDescription: 'Enter link description',
    enterTextContent: 'Enter text content',
    enterObservation: 'Enter observation',
    modalDescriptionDetail: 'The files in this list have been previously uploaded. Files already attached are not shown.',


    // Department/Functional Area
    department: 'Department',
    functionalArea: 'Functional Area',
    selectDepartment: 'Select Department',
    selectFunctionalArea: 'Select Functional Area',

    // Input placeholders
    enterAnswer: 'Enter answer',
    enterNumberAnswer: 'Enter number',

    // Actions
    save: 'Save',
    saving: 'Saving...',
    savingMessage: 'Please wait while the form is being saved.',
    done: 'Done',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    editing: 'EDITING',
    clone: 'Clone',
    cloning: 'Cloning...',
    cloneSuccess: 'Cloning completed successfully',
    cloneError: 'Error during cloning',
    cloningQuestion: 'Cloning question...',
    cloneQuestionSuccess: 'Question cloned successfully',
    deleteForm: 'Delete form',
    confirmDelete: 'Are you sure you want to delete this form?',
    deleteSuccess: 'Form deleted successfully',
    deleteError: 'Error deleting form',
    actions: 'Actions',
    search: 'Search',
    clear: 'Clear',
    assignForm: 'Assign form',

    // Finder specific labels
    date: 'Creation date',
    createdBy: 'Created by',
    findedElements: 'Found Elements',
    filter: 'Filter',
    formBuilderFinder: 'Form Builder Finder',
    noResults: 'No results found',

    // Dashboard specific
    healthAuthority: 'Health Authority',
    departmentCategory: "Department's Category",
    customDepartmentCategory: 'Custom Department Category',
    observer: 'Observer',
    sessionLength: 'Session length',
    notes: 'Notes',
    startDate: 'Start date',
    endDate: 'End date',
    id: 'Id',
    startEnd: 'Start and End Time',
    notesPlaceholder: 'Write your notes here',
    savingData: 'We are saving your data',
    handHygieneSavedSuccesfully: 'Hand Hygiene Sheet saved successfully',
    handHygieneSavingError: 'Error saving Hand Hygiene Sheet',
    departmentTypeRequired: "Department type not selected",
    startDateTimeRequired: 'Start Time need to be selected',
    endDateTimeRequired: 'End Time need to be selected',
    endDateTimeBeforeStart: 'End Time cannot be earlier than Start Time',
    departmentRequired: 'Department is a mandatory field',
    functionalAreaRequired: 'Functional area is a mandatory field',
    opportunityMissingOperator: 'Opportunities are defined in OPP {{opp}} but no operator is assigned',
    incompleteOpportunity: 'OPP {{oppIndex}} of operator {{operatorOrder}} is incomplete: must select both indication and hand hygiene action',
    nothingToSave: 'Nothing to save',
    acpm: 'Acpm',
    note: 'Notes',
    opp: 'Opp',
    pageRows: 'Page rows:',
    backPage: 'Back',
    nextPage: 'Next',
    pageOf: 'Page {{currentPage}} of {{totalPages}}',
    emptyAssigned: "No assigned forms",
    emptySaved: "No saved forms",
    emptyCompiled: "No compiled forms",
    emptyApproved: "No approved forms",
    Name: 'Name',
    Description: 'Description',
    Group: 'Group',
    Code: 'Code',
    Status: 'Status',
    Assigned: 'Assigned',
    Saved: 'Saved',
    Compiled: 'Compiled',
    Approved: 'Approved',
    CompiledForms: 'Compiled Forms',

    // Sections Builder specific
    cloneSection: 'Clone section',

    // Questions Builder specific
    type: 'Type',
    openAnswer: 'Open Answer',
    openNumberAnswer: 'Open Answer (Numbers)',
    files: 'Files',
    answers: 'Answers',
    condition: 'Condition',

    // Validation Dashboard specific
    validationDashboard: 'Validation Dashboard',
    selectUser: 'Select user',
    selectForm: 'Select form',
    Compiler: 'Compiler',
    CreatedDate: 'Creation Date',
    validate: 'Validate',
    validationSuccess: 'Form validated successfully',
    validationError: 'Error validating form',
    confirmValidation: 'Are you sure you want to validate this form?',
    requiresValidation: 'Requires validation',
    validated: 'Validated',
    validatedBy: 'Validated by',
    validatedDate: 'Validation date',
    view: 'View',
    viewForm: 'View Form',
    loadingFormData: 'Loading form data...',
    failedToLoadForm: 'Failed to load form data',
    viewingForm: 'Viewing Form',

    // Form Assignment specific
    formAssignment: 'Form Assignment',
    assign: 'Assign',
    assignSuccess: 'Form assigned successfully',
    assignError: 'Error assigning form',
    formAssignmentInfo: 'Select a user to assign the form to',
    userRequired: 'Select at least one user or form',
    back: 'Back',
    requiredField: 'Required field',
    expectedStartDate: 'Expected start date',
    expectedEndDate: 'Expected end date',
    assignToUser: 'Assign to User',
    assignToGroup: 'Assign to Group',
    collaborativeAssignment: 'Collaborative Assignment',
    collaborativeAssignmentInfo: 'Collaborative assignment: select a collaborative form to create an assignment open to all users.',
    actorRoleMapping: 'Actor-Role Mapping',
    actorRoleMappingRequired: 'All actors must be assigned to at least one role to proceed.',
    selectRoles: 'Select one or more roles',
    selectRoleToAdd: 'Select a role to add',
    assignedRoles: 'Assigned roles',
    noRolesAssigned: 'No roles assigned',
    noActorsFound: 'No actors found for this form',
    actorsWithoutRoles: 'The following actors have no roles assigned',
    remove: 'Remove',
    selectGroup: 'Select group',
    groupRequired: 'Select at least one group or form',
    cycles: 'Cycles',
    selectBusinessUnits: 'Select Business Units',
    selectBusinessUnitToAdd: 'Select a business unit to add',
    selectedBusinessUnits: 'Selected Business Units',
    noBusinessUnitsSelected: 'No business units selected',
    businessUnitsInfo: 'Select one or more business units for this collaborative assignment.',
    businessUnitRequired: 'Select at least one business unit',
    freeAssignments: 'Free assignments',
    freeAssignmentsInfo: 'Allows assigning actors to all users',
    assignmentWithNotification: 'Assignment with notification',
    assignmentWithNotificationInfo: 'Send notification to users based on compilation order',
    allUsersInfo: 'This actor can be compiled by all users',
    rolesDisabledForAllUsers: 'Role selection is disabled when "All users" is active',
    importantNote: 'Important note',
    allUsersOrderRestriction: 'Actors with "All users" must be positioned at the beginning of the compilation sequence. After an actor with specific roles, it is no longer possible to insert actors with "All users". At least one actor must have specific roles.',
    atLeastOneActorWithRoles: 'At least one actor must have specific roles assigned. Not all actors can be set to "All users".',
    allUsersActorsMustBeFirst: 'Actors with "All users" must be positioned at the beginning of the compilation sequence.',
    newAssignment: 'New Assignment',
    searchAssignments: 'Search Assignments',
    searchAssignmentsInfo: 'Search and manage existing assignments using the filters below.',
    comingSoon: 'Coming Soon',
    searchAssignmentsComingSoon: 'The assignment search functionality will be available soon.',
    allUsers: 'All users',
    allGroups: 'All groups',
    allValidationTypes: 'All types',
    searchDateFrom: 'Start date from',
    searchDateTo: 'End date before',
    includeInactive: 'Include inactive',
    searching: 'Searching...',
    searchResults: 'Search results',
    noAssignmentsFound: 'No assignments found',
    useFiltersToSearch: 'Use the filters above to search for assignments and click "Search".',
    assignedTo: 'Assigned to',
    assignmentType: 'Type',
    createdDate: 'Creation date',
    status: 'Status',
    user: 'User',
    group: 'Group',
    searchError: 'Error searching assignments',
    allForms: 'All forms',
    endDateMustBeAfterStartDate: 'End date must be after start date',
    startDateMustBeBeforeEndDate: 'Start date must be before end date',
    editAssignment: 'Edit Assignment',
    editAssignmentInfo: 'Edit the details of the selected assignment.',
    confirmSave: 'Confirm Save',
    areYouSureToSave: 'Are you sure you want to save the changes?',
    updateSuccess: 'Assignment updated successfully',
    updateError: 'Error updating assignment',
    confirmDelete: 'Confirm Delete',
    areYouSureToDelete: 'Are you sure you want to delete this assignment? This action cannot be undone.',
    deleting: 'Deleting...',
    deleteSuccess: 'Assignment deleted successfully',
    deleteError: 'Error deleting assignment',
    saveChanges: 'Save Changes',
    compilationOrder: 'Compilation order',
    order: 'Order',
    resetOrder: 'Reset order',
    duplicateOrderValues: 'Each actor must have a unique compilation order. Check for duplicates.',
    invalidOrderRange: 'Order must be between 1 and',
    searchUserPlaceholder: 'Type at least 3 characters to search users...',
    searchGroupPlaceholder: 'Type at least 2 characters to search groups...',
    noUsersFound: 'No users found',
    noGroupsFound: 'No groups found',

    // Notification Settings
    notificationSettings: 'Notification Settings',
    automaticNotification: 'Automatic',
    customNotification: 'Custom',
    notificationEmails: 'Notification emails',
    enterEmail: 'Enter email...',
    noEmailsAdded: 'No emails added',
    emailEmpty: 'Email cannot be empty',
    emailInvalid: 'Invalid email format',
    emailDuplicate: 'This email is already in the list',
    customNotificationRequiresEmails: 'Custom notification requires at least one email',

    // New Dashboard specific
    assignmentsDashboard: 'Assignments Dashboard',
    assignmentsDashboardDescription: 'Manage and monitor your form assignments.',
    activeAssignments: 'Active Assignments',
    completedAssignments: 'Completed Assignments',
    assignmentPeriod: 'Assignment Period',
    completedCycles: 'Completed Cycles',
    remainingCycles: 'Remaining Cycles',
    totalCycles: 'Total Cycles',
    formCompletions: 'Form Completions',
    compiledBy: 'Compiled by',
    completedCycle: 'Completed Cycle',
    noCompletionsYet: 'No completions available yet',
    noActiveAssignments: 'No active assignments',
    noCompletedAssignments: 'No completed assignments',
    noActiveAssignmentsDescription: 'You currently have no active form assignments.',
    noCompletedAssignmentsDescription: 'You have not completed any assignments yet.',
    allCyclesCompleted: 'All cycles for this assignment have been completed.',
    assignedToGroup: 'Assigned to group',
    details: 'details',
    viewingForm: 'Viewing Form',
    loadingFormData: 'Loading form data...',
    failedToLoadForm: 'Failed to load form data',
    refresh: 'Refresh',
    view: 'View',

    // Compiler specific
    enterText: 'Enter text',
    option: 'Option',
    section: 'Section',
    chooseFile: 'Choose file',
    chooseFromExisting: 'Choose from existing',
    uploadNewFile: 'Upload new file',
    fileSelected: 'File selected',
    fileUploaded: 'File uploaded',
    orClickToSelect: 'or click to select',
    fileUploadSuccessful: 'File upload successful',
    noFileSelected: 'No file selected',
    fileSize: 'Size',
    lastUpdated: 'Last updated',
    enterLink: 'Enter URL',
    enterObservation: 'Enter observation',
    linkAdded: 'Link added',
    observationAdded: 'Observation added',
    providedLink: 'Provided link',
    providedObservation: 'Provided observation',
    enterValidUrl: 'Enter a valid URL',
    attachment: 'Attachment',
    textAdded: 'Text added',
    providedText: 'Provided text',
    na: 'Not Applicable',
    selectDate: 'Select date',
    selectTime: 'Select time',
    selectDateTime: 'Select date and time',
    selectVocabulary: 'Select from vocabulary',
    selectCustomVocabulary: 'Select Custom Vocabulary',
    loadingVocabulary: 'Loading vocabulary...',
    loadingVocabularies: 'Loading vocabularies...',
    customVocabularyColumnHelp: 'Cells in the column will show a list from the selected vocabulary.',
    noVocabularyItemsFound: 'No items found in this vocabulary',
    loadingDepartments: 'Loading departments...',
    loadingFunctionalAreas: 'Loading functional areas...',
    readOnlyMode: 'Read-Only Mode',
    readOnlyInfo: 'This form is in read-only mode. You cannot modify the answers.',
    formTest: 'Form Test',
    formSimulation: 'This is a form simulation. Responses will not be saved.',
    submitAnswers: 'Submit Answers',
    formSubmittedSuccessfully: 'Form submitted successfully.',
    formCompilation: 'Form Compilation',
    formCompilationInfo: 'Complete the form and save your answers.',
    savingFormData: 'Saving form data',
    formSavedSuccessfully: 'Form saved successfully',
    failedToSaveForm: 'Failed to save form',
    reload: 'Reload Form',
    reloadConfirmation: 'This will reload the form with the last saved data. Any unsaved changes will be lost. Continue?',
    mandatorySectionIncomplete: 'Mandatory section incomplete',
    incompleteMandatoryQuestions: 'Incomplete mandatory questions',
    validationError: 'Validation error',
    submitting: 'Submitting...',
    submittingFormData: 'Submitting form data',
    failedToSubmitForm: 'Failed to submit form',

    // Question Validation System
    validationRules: 'Validation Rules',
    validationRulesNote: 'These rules are automatically applied during form completion.',
    validationRule: 'Validation rule',
    optionDisabledByValidation: 'Option disabled by validation rules',
    anyOfThese: 'any of these',
    allOfThese: 'all of these',
    noneOfThese: 'none of these',
    mustSelectOneOf: 'must select at least one of',
    mustSelectAllOf: 'must select all of',
    cannotSelect: 'cannot select',
    if: 'If',
    then: 'then',
    // Validation editor interface
    validationRulesInfo: 'How validation rules work',
    validationRulesDescription: 'Rules follow IF/THEN logic to control allowed answer combinations. Each rule defines a trigger condition and a resulting action.',
    noValidationRules: 'No validation rules configured',
    clickAddRule: 'Click "Add Rule" to get started',
    rule: 'Rule',
    removeRule: 'Remove rule',
    sourceCondition: 'Trigger condition',
    sourceAnswers: 'Trigger answers',
    destCondition: 'Resulting action',
    destAnswers: 'Target answers',
    preview: 'Preview',
    addRule: 'Add Rule',
    any_of: 'any of these',
    all: 'all of these',
    not_in: 'none of these',
    mandatory_any: 'must select at least one of',
    mandatory_all: 'must select all of',
    excluded_all: 'cannot select',

    // Language
    selectLanguage: 'Select language',
    english: 'English',
    italian: 'Italian',
    enterTextIn: 'Enter text in',

    // Simulation
    simulation: 'Simulation',
    simulateForm: 'Simulate form',
    compileForm: 'Compile form',

    // Messages
    success: 'Success',
    error: 'Error',
    attention: 'Attention',
    loading: 'Loading...',
    saveSuccess: 'Form saved successfully.',
    createSuccess: 'Form created successfully.',
    updateSuccess: 'Form updated successfully.',
    saveError: 'An error occurred while saving the form.',
    duplicateCodesFound: 'Duplicate codes were found in the form:',
    invalidResponse: 'Server returned an invalid response. Please check the API endpoint and server configuration.',
    mandatorySectionError: 'The section "{sectionName}" is mandatory and contains unanswered questions. Complete all questions before saving.',
    mandatoryQuestionInSection: 'Mandatory questions in section',

    // Navigation
    home: 'Home',
    form: 'Form',
    searchForms: 'Search forms',
    formsDashboard: 'Forms Dashboard',
    formsDashboardWelcome: 'Welcome to the Forms Dashboard.',

    // Boolean values
    yes: 'Yes',
    no: 'No',
    true: 'True',
    false: 'False',

    // File operations
    download: 'Download',

    // Link and Text operations
    providedLink: 'Provided Link',
    enterLink: 'Enter link',
    linkAdded: 'Link added',
    enterValidUrl: 'Enter a valid URL',
    providedText: 'Provided Text',
    enterText: 'Enter text',
    textAdded: 'Text added',
    providedObservation: 'Provided Observation',
    observationAdded: 'Observation added',

    // Conditions
    createCondition: 'Create a condition to control when this question appears',
    selectConditionType: 'Select condition type...',
    andGroup: 'AND Group (all conditions must be true)',
    orGroup: 'OR Group (any condition can be true)',
    operator: 'Operator',
    answer: 'Answer',
    selectQuestion: 'Select question...',
    selectAnswer: 'Select answer...',
    isEqualTo: 'is equal to',
    isNotEqualTo: 'is not equal to',
    removeCondition: 'Remove condition',
    addCondition: 'Add Condition',
    addAnd: 'Add AND',
    addOr: 'Add OR',
    removeEntireCondition: 'Remove entire condition',
    allMustBeTrue: 'All must be true',
    anyCanBeTrue: 'Any can be true',
    addConditionsOrGroups: 'Add conditions or groups using the buttons above',
    loadingQuestions: 'Loading questions...',

    // Validation
    required: 'Required',
    optional: 'Optional',

    // Default Answers
    defaultAnswers: 'Default Answers',
    selectDefaultAnswers: 'Select default answers (optional)',
    singleDefaultHelp: 'Select one answer that will be preselected by default',
    multipleDefaultHelp: 'Select one or more answers that will be preselected by default',
    booleanDefaultHelp: 'Select the default true/false value',
    yesNoNADefaultHelp: 'Select the default yes/no/not applicable value',
    pdcaDefaultHelp: 'Select one or more default PDCA options',
    customVocabularyDefaultHelp: 'Select one or more default items from the custom vocabulary',
    clearDefaultAnswers: 'Clear Default Answers',
    hide: 'Hide',
    show: 'Show',

    // Export Form
    exportForm: 'Export Form',
    exporting: 'Exporting...',
    exportingForm: 'Exporting form, please wait.',
    exportSuccess: 'Form exported successfully',
    exportError: 'Error exporting form',
    noFormToExport: 'No form to export',
    saveBeforeExport: 'Save changes before exporting the form',

    // Import Form
    importForm: 'Import Form',
    importing: 'Importing...',
    importingForm: 'Importing form, please wait.',
    importSuccess: 'Form imported successfully',
    importError: 'Error importing form',
    invalidFileFormat: 'Invalid file format. File must be a valid JSON.',

    // Table specific labels
    tableData: 'Table Data',
    tableEmpty: 'No data in table',
    tableRowAdded: 'Row added',
    tableRowDeleted: 'Row deleted',
    tableRowDeleteConfirm: 'Are you sure you want to delete this row?',
    tableColumnName: 'Column Name',
    tableColumnType: 'Column Type',
    tableColumnRequired: 'Required Column',
    tableRow: 'Row',
    tableAction: 'Action',
    tableNoColumns: 'No columns configured for this table',
    tableConfigureColumns: 'Configure columns in question settings',
    rowNumber: 'No.',
    cannotDeleteVocabularyItems: 'Cannot delete vocabulary items',
    cannotAddVocabularyItems: 'Cannot add custom vocabulary items',
    cannotReorderVocabularyItems: 'Cannot reorder vocabulary items',
    noFilesRequired: 'No files required',
    add: 'Add',
    placeholder: 'Placeholder',

    // ACPM (Azioni Correttive e Piani di Miglioramento) Labels
    acpmFinder: 'ACPM Form Finder',
    acpmList: 'ACPM Forms List',
    objective: 'Objective',
    action: 'Action',
    responsabile: 'Responsible',
    dataInizio: 'Start Date',
    dataFine: 'End Date',
    stato: 'Status',
    esito: 'Result',
    acpmFormsList: 'ACPM Forms Found',
    loadingACPMForms: 'Loading ACPM forms...',
    errorLoadingACPMForms: 'Error loading ACPM forms',
    noACPMFormsFound: 'No ACPM forms found',
    acpmFormCode: 'ACPM Code',
    viewDetails: 'View Details',
    refreshACPMList: 'Refresh ACPM List',

    // Collaborative Form Lock System
    formLocked: 'Form in use',
    formLockedBy: 'Being edited by',
    formLockedMessage: 'This form is currently being edited by another user. You cannot modify it at this time.',
    lockActive: 'You are editing',
    lockActiveMessage: 'You have exclusive control of this collaborative form',
    lockError: 'Lock error',
    lockErrorMessage: 'An error occurred while acquiring the form lock',
    retryLock: 'Retry',
    backToList: 'Back to list',
    acquiringLock: 'Acquiring lock...',
    acquiringLockMessage: 'Please wait while acquiring the collaborative form lock',
    lockDisconnected: 'Disconnected',
    lockDisconnectedMessage: 'You have been disconnected from the form. The lock has been released.'
  }
}; 